import { useEffect, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import { useAppDispatch } from 'store/store';
import { loadSettings } from 'store/settings/settings.thunk';
import AppShell from 'shared/components/AppLayout/AppShell';

const Home = lazy(() => import('./home'));
const Hunts = lazy(() => import('./app/hunts'));
const HuntDetails = lazy(() => import('./app/hunts/details'));
const TreasureDetails = lazy(() => import('./app/treasures/details'));
const Profile = lazy(() => import('./app/profile'));
const Settings = lazy(() => import('./app/settings'));
const Upgrade = lazy(() => import('./app/upgrade'));
const Help = lazy(() => import('./app/help'));
const TreasureMap = lazy(() => import('./app/treasure-map'));
const Search = lazy(() => import('./app/search'));
const Favorites = lazy(() => import('./app/favorites'));
const Feed = lazy(() => import('./app/feed'));
const Invites = lazy(() => import('./app/invites'));
const Notifications = lazy(() => import('./app/notifications'));

const Login = lazy(() => import('./auth/login'));
const Signup = lazy(() => import('./auth/signup'));
const PhoneSignIn = lazy(() => import('./auth/phone'));
const Confirm = lazy(() => import('./auth/confirm'));
const ConfirmationStatus = lazy(() => import('./auth/confirm/status'));
const ForgotPassword = lazy(() => import('./auth/forgot-password'));
const RecoverPassword = lazy(() => import('./auth/recover-password'));
const SocialCallback = lazy(() => import('./auth/social-callback'));

const ChangePassword = lazy(() => import('./app/profile/change-password'));
const PhoneNumber = lazy(() => import('./app/profile/phone'));
const DeleteAccount = lazy(() => import('./app/profile/delete-account'));
const ConfirmEmail = lazy(() => import('./app/profile/confirm-email'));
const Success = lazy(() => import('./app/upgrade/success'));

const MainRouter = () => {
  const dispatch = useAppDispatch();

  // Load user settings to store
  useEffect(() => {
    dispatch(loadSettings());
    // eslint-disable-next-line
  }, []);

  return (
    <Routes>
      <Route path="/">
        <Route index element={<Home />} />
        {/* <Route path="pricing" element={<Pricing />} /> */}
        {/* <Route path="come-back-soon" element={<ComeBackSoon />} /> */}
        <Route path="auth">
          <Route path="login" element={<Login />} />
          <Route path="signup" element={<Signup />} />
          <Route path="phone" element={<PhoneSignIn />} />
          <Route path="confirm/:token" element={<Confirm />} />
          <Route path="confirm/status" element={<ConfirmationStatus />} />
          <Route path="forgot-password" element={<ForgotPassword />} />
          <Route path="recover/:token" element={<RecoverPassword />} />
          <Route path="social/callback" element={<SocialCallback />} />
        </Route>
        {/* Full-screen plan picker, outside the app shell */}
        <Route path="upgrade" element={<Upgrade />} />
        {/* The signed-in app: the navigation stays mounted while pages change */}
        <Route element={<AppShell />}>
          <Route path="hunts">
            <Route index element={<Hunts />} />
            <Route path=":huntId" element={<HuntDetails />} />
          </Route>
          <Route path="treasures">
            <Route path=":treasureId" element={<TreasureDetails />} />
          </Route>
          <Route path="profile">
            <Route index element={<Profile />} />
            <Route path="change-password" element={<ChangePassword />} />
            <Route path="phone" element={<PhoneNumber />} />
            <Route path="delete-account" element={<DeleteAccount />} />
            <Route path="confirm-email" element={<ConfirmEmail />} />
          </Route>
          <Route path="settings" element={<Settings />} />
          <Route path="upgrade/success" element={<Success />} />
          <Route path="help" element={<Help />} />
          <Route path="map" element={<TreasureMap />} />
          <Route path="search" element={<Search />} />
          <Route path="feed" element={<Feed />} />
          <Route path="saved" element={<Favorites />} />
          <Route path="invites" element={<Invites />} />
          <Route path="notifications" element={<Notifications />} />
        </Route>
      </Route>
    </Routes>
  );
};

export default MainRouter;
